<template>
    <div class="body">
        <div v-show="ReportData.visitsLab=='内在驱动者'">
            <p class="p1" style="padding-top: 8vh;">🔍 懂得回望，才能走得更远</p>
            <p class="p5">你开始关注自己的学习成就，</p>
            <p class="p6">每一次回顾，都是一次自我确认。</p>
            <p class="p7">你是一位 <a class="highlight" style="font-size: 24px;">{{ ReportData.visitsLab }}</a> </p>
            <p class="p7">你不会频繁查看数据，</p>
            <p class="p7">但你知道什么时候该停下来看看自己。</p>
            <p class="p7">学习不是表演，</p>
            <p class="p7">而是为真正需要的时刻做准备。</p>
        </div>
        <div v-show="ReportData.visitsLab=='阶段复盘者'">
            <p class="p1" style="padding-top: 8vh;">🌱 成长，始于觉察</p>
            <p class="p5">你开始关注学习成果与过程，</p>
            <p class="p6">让努力变得看得见。</p>
            <p class="p7">你是一位 <a class="highlight" style="font-size: 24px;">{{ ReportData.visitsLab }}</a> </p>
            <p class="p7">你会在关键节点回顾学习成果，</p>
            <p class="p7">确认自己是否走在正确的路上，</p>
            <p class="p7">这是成熟学习者的典型特征。</p>
        </div>
        <div v-show="ReportData.visitsLab=='持续反思者'">
            <p class="p1" style="padding-top: 8vh;">⏳ 前行不忘回望</p>
            <p class="p5">你在记录中看见自己的努力，</p>
            <p class="p6">在回顾中，为下一步积蓄方向。</p>
            <p class="p7">你是一位 <a class="highlight" style="font-size: 24px;">{{ ReportData.visitsLab }}</a> </p>
            <p class="p7">你反复回看自己的学习足迹，</p>
            <p class="p7">因为你在意进步，也在意方向。</p>
            <p class="p7">学习，对你来说不是一次性任务，</p>
            <p class="p7">而是一场持续校准的过程。</p>
        </div>
    </div>
</template>

<script>
export default {
  props: [ "ReportData"],
  data() {
      return {
          
      }
  },
}
</script>

<style scoped>
.body {
  background: url("../../assets/25October/logo.png") right  top  no-repeat,
              /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
              url("../../assets/25Year/bg.png")  no-repeat;
  background-size:100% 100%,cover;
  width: 100%;
  height: 100vh;
}
.p1,.p2, .p3, .p4 {
  width: 88%;
  margin: 0 auto;
  text-align: left;
  font-size: 18px;
  color: #fff;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
  font-size: 30px;
  color: purple;
  text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  font-weight: bolder;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p6, .p7, .p8{
  width: 88%;
  margin: 0 auto;
  text-align: left;
  font-size: 16px;
  color: #fff;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p7{
  margin-top: 20px;
}
@media screen and (min-width: 786px) {
.body {
  background: 
              url("../../assets/25Year/pcbg.jpg")  no-repeat;
  background-size:cover;
  width: 100%;
  height: 100vh;
}
.p1,.p2, .p3, .p4 {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-size: 25px;
  color: #fff;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
  font-size: 26px;
  color: purple;
  text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  font-weight: bolder;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p6, .p7, .p8{
  margin:0 auto;
  text-align: center;
  font-size: 20px;
  width: 92%;
}

.p5, .p7{
  margin-top: 20px;
}
}
</style>